<template>
  <div>
    <videoH></videoH>
    <CompanyProfile data-aos="fade-up"></CompanyProfile>
    <Banner data-aos="fade-up"></Banner>
    <Unit data-aos="fade-up"></Unit>
    <History data-aos="fade-up"></History>
    <BottomImg data-aos="fade-up"></BottomImg>
  </div>
</template>

<script>
import AOS from 'aos';

import VideoH from '@/views/home/video.vue'
import CompanyProfile from '@/views/home/products/CompanyProfile.vue';
import History from '@/views/home/products/History.vue';
import Banner from '@/views/home/products/Banner.vue';
import Unit from '@/views/home/products/Unit.vue';
import BottomImg from '@/views/home/products/BottomImg.vue';

export default {
  name: 'Home',
  components: {
    VideoH,
    CompanyProfile,
    History,
    Banner,
    Unit,
    BottomImg
  },
  mounted() {
    AOS.refresh();
  },
}
</script>


// WEBPACK FOOTER //
// src/views/home/Home.vue